<template>
  <div
    itemscope
    itemprop="mainEntity"
    itemtype="https://schema.org/Question"
  >
    <component
      :is="itemCollapsible?'button':'div'"
      class="faq-item"
      data-ident="faqItem"
      @click.prevent="collapseAnswer()"
    >
      <h3
        itemprop="name"
        class="row"
      >
        <span
          class="text"
          :class="{'col-11':itemCollapsible,'col-12':!itemCollapsible}"
        >{{ itemHead }}</span>
        <span :class="{'col-1':itemCollapsible,'d-none':!itemCollapsible}">
          <i class="icon">
            <icon-chevron-down v-show="itemCollapsible" />
            <icon-chevron-up v-show="showAnswer" />
          </i>
        </span>
      </h3>
    </component>
    <div
      v-show="showAnswer"
      :class="{collapsed:!showAnswer}"
      itemscope
      itemprop="acceptedAnswer"
      itemtype="https://schema.org/Answer"
    >
      <div
        v-dompurify-html="itemText"
        itemprop="text"
      />
    </div>
  </div>
</template>

<script>
import IconChevronDown from 'ICON:IconChevronDown';
import IconChevronUp from 'ICON:IconChevronUp';

export default {
  name: 'FaqItem',
  components: {
    IconChevronDown,
    IconChevronUp
  },
  props: {
    itemHead: {
      type: String,
      default: 'Die Frage aller Fragen'
    },
    itemText: {
      type: String,
      default: 'Die Antwort auf alle Fragen'
    },
    itemCollapsible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      collapsed: true,
    };
  },
  computed: {
    showAnswer() {
      if (!this.itemCollapsible) { return true; }
      return this.itemCollapsible && !this.collapsed;
    },
  },
  methods: {
    collapseAnswer() {
      if (this.itemCollapsible) { // if collapsible
        this.collapsed = !this.collapsed; // toggle state
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.faq-item{
  width:100%;
  display: block;
  h3{
    text-align: left;
  }
}
</style>
